import { query } from "../../../app/query";
import { Options } from "../../../common/types/requestOptions";
import { CalendarEventFilters, TalentCalendarEvent } from "./types";

export const getTalentCalendarEvents = (
  filters: CalendarEventFilters,
  options: Options = {},
): Promise<TalentCalendarEvent[]> => {
  return query<CalendarEventFilters, TalentCalendarEvent[]>(
    "/projections/qry/talentCalendarEvents",
    filters,
    options,
  );
};

/**
 * Mock API for testing calendar UI without backend
 * Simulates API call with delay and returns hardcoded events
 */
export const getTalentCalendarEventsMock = (
  filters: CalendarEventFilters,
  options: Options = {},
): Promise<TalentCalendarEvent[]> => {
  console.log("🎭 Mock API called with filters:", filters);

  return new Promise((resolve) => {
    // Simulate network delay
    const delay = 600;

    setTimeout(() => {
      const now = new Date();
      const currentMonth = now.getMonth();
      const currentYear = now.getFullYear();

      // Generate mock events for current month
      const mockEvents: TalentCalendarEvent[] = [
        // Work entries
        {
          id: "mock-work-1_1",
          start: new Date(currentYear, currentMonth, 5, 9, 0).getTime(),
          end: new Date(currentYear, currentMonth, 5, 13, 0).getTime(),
          type: "WorktimeEntry",
        },
        {
          id: "mock-work-1_2",
          start: new Date(currentYear, currentMonth, 5, 13, 0).getTime(),
          end: new Date(currentYear, currentMonth, 5, 17, 0).getTime(),
          type: "WorktimeEntry",
        },
        {
          id: "mock-work-1_3",
          start: new Date(currentYear, currentMonth, 5, 17, 30).getTime(),
          end: new Date(currentYear, currentMonth, 5, 20, 0).getTime(),
          type: "WorktimeEntry",
        },
        {
          id: "mock-work-2",
          start: new Date(currentYear, currentMonth, 8, 8, 0).getTime(),
          end: new Date(currentYear, currentMonth, 8, 16, 30).getTime(),
          type: "WorktimeEntry",
        },
        {
          id: "mock-work-3",
          start: new Date(currentYear, currentMonth, 12, 10, 0).getTime(),
          end: new Date(currentYear, currentMonth, 12, 18, 0).getTime(),
          type: "WorktimeEntry",
        },
        {
          id: "mock-work-4",
          start: new Date(currentYear, currentMonth, 15, 9, 0).getTime(),
          end: new Date(currentYear, currentMonth, 15, 15, 0).getTime(),
          type: "WorktimeEntry",
        },
        {
          id: "mock-work-5",
          start: new Date(currentYear, currentMonth, 19, 8, 30).getTime(),
          end: new Date(currentYear, currentMonth, 19, 17, 30).getTime(),
          type: "WorktimeEntry",
        },
        {
          id: "mock-work-6",
          start: new Date(currentYear, currentMonth, 22, 9, 0).getTime(),
          end: new Date(currentYear, currentMonth, 22, 16, 0).getTime(),
          type: "WorktimeEntry",
        },
        {
          id: "mock-work-7",
          start: new Date(currentYear, currentMonth, 26, 10, 0).getTime(),
          end: new Date(currentYear, currentMonth, 26, 14, 0).getTime(),
          type: "WorktimeEntry",
        },

        // Unavailability entries
        {
          id: "mock-unavail-1",
          start: new Date(currentYear, currentMonth, 3, 6, 30).getTime(),
          end: new Date(currentYear, currentMonth, 3, 13, 0).getTime(),
          type: "UnavailabilityEntry",
        },
        {
          id: "mock-unavail-2",
          start: new Date(currentYear, currentMonth, 10, 0, 0).getTime(),
          end: new Date(currentYear, currentMonth, 10, 23, 59).getTime(),
          type: "UnavailabilityEntry",
        },
        {
          id: "mock-unavail-3",
          start: new Date(currentYear, currentMonth, 17, 0, 0).getTime(),
          end: new Date(currentYear, currentMonth, 18, 23, 59).getTime(),
          type: "UnavailabilityEntry",
        },
        {
          id: "mock-unavail-4",
          start: new Date(currentYear, currentMonth, 24, 0, 0).getTime(),
          end: new Date(currentYear, currentMonth, 25, 23, 59).getTime(),
          type: "UnavailabilityEntry",
        },
      ];

      console.log(
        `✅ Mock API returning ${mockEvents.length} events after ${delay.toFixed(0)}ms`,
      );
      resolve(mockEvents);
    }, delay);
  });
};
